<template>
  <div class="con">
    <titlebar :name="page_name" :is_custom_back="true" @goBackCustom="goBack" />
    <div class="desk-right">
      <div class="switch">
        <div class="switch-item">
          <span>兑换类型</span>
          <van-radio-group v-model="type" direction="horizontal" :disabled="shop.user_model != 1">
            <van-radio name="1">优惠券</van-radio>
          </van-radio-group>
        </div>
        <div class="switch-item auto-height-s-i">
          <span>优惠券</span>
          <div class="s-i-field s-i-field-coupon">
            <button class="ff-chaoose-btn" @click="openCouponModal">选择优惠券</button>
            <div class="index_box choosed-coupon-box" v-if="Object.keys(choosed_coupon).length">
              <div class="coupon-left">
                <div class="color-1588F5 mg-bt15">
                  <span class="mg-rt5 ft-40 ft-bold">{{ choosed_coupon.face }}</span>
                  <span class="ft-22" v-if="choosed_coupon.type == 1" style="vertical-align: text-top;">元</span>
                  <span class="ft-22" v-if="choosed_coupon.type == 2" style="vertical-align: text-top;">折</span>
                </div>
                <div class="ft-20 color-333">满{{ choosed_coupon.cill }}可用</div>
              </div>
              <div style="flex: 1;" class="pd-lt20 pd-rt5">
                <div class="ft-22 color-333 mg-bt25">{{ choosed_coupon.name }}</div>
                <div v-if="choosed_coupon.period == 1" class="ft-20 color-666">领券后{{ choosed_coupon.day }}天内有效</div>
                <div v-if="choosed_coupon.period == 2" class="ft-20 color-666">有效期：{{ choosed_coupon.start_time }} 至 {{ choosed_coupon.end_time }}</div>
                <div v-if="choosed_coupon.period == 3" class="ft-20 color-666">有效期：长期有效</div>
              </div>
            </div>
          </div>
        </div>
        <div class="switch-item">
          <span>兑换所需积分</span>
          <div class="s-i-field">
            <input v-if="platform_name == 'android'" v-model="score" class="face-price-input mg-rt20" readonly @click="openKeyboard('score')" />
            <input v-else v-model="score" type="number" class="face-price-input mg-rt20" />
          </div>
        </div>
        <div class="switch-item">
          <span>状态</span>
          <div class="s-i-field">
            <van-switch v-model="status" active-color="#1890FF" size="3.6rem" :disabled="shop.user_model != 1" />
          </div>
        </div>
      </div>
      <div style="height: 10rem;"></div>
      <div class="foot_btn_box" v-if="shop.user_model == 1">
        <van-button v-if="id" class="foot_btn" style="margin-right: 10rem; background: #e60012; color: #fff;" @click="openDialog()">删除</van-button>
        <van-button v-else class="foot_btn" style="margin-right: 10rem;" @click="goBack">取消</van-button>
        <van-button class="foot_btn foot_submit" @click="onSubmit()">保存</van-button>
      </div>
    </div>

    <popupOfDialog
      v-if="showDialog"
      :type="dialogType"
      :title="dialogTitle"
      :message="dialogMsg"
      :data="dialogData"
      @closePopDialog="closePopDialog"
      @confirmPopDialog="confirmPopDialog"
    ></popupOfDialog>

    <van-number-keyboard 
      v-model="numVal" 
      :title="numVal" 
      :show="show_keyboard" 
      extra-key="." 
      @blur="show_keyboard = false;" 
      @input="handleNumChange" 
      @delete="handleNumDelete"
      class="otherEatNum-nk" 
    />

    <!-- 选择优惠券 开始 -->
    <div class="choose-coupon-modal" v-if="show_choose_coupon">
      <div class="modal-content-box relative" style="z-index: 2002;">
        <img src="@/static/images/close.png" class="close absolute" alt srcset @click="closeCouponModal" />

        <div class="wrapper">
          <!-- 标题 -->
          <div class="title color-333 ft-28 flex flex-ac flex-jc ft-bold' pd-bt25">选择优惠券</div>

          <div class="mocontent">
            <div class="deskcontent">
              <div class="index_list">
                <div v-for="(item, i) in modal_coupon_list" :key="i" class="index_box relative" @click="chooseThatCoupon(item)">
                  <van-checkbox class="del-checkbox" icon-size="2.6rem" :value="select_coupon.id == item.id" shape="square" />
                  <div class="coupon-left">
                    <div class="color-1588F5 mg-bt15">
                      <span class="mg-rt5 ft-40 ft-bold">{{ item.face }}</span>
                      <span class="ft-22" v-if="item.type == 1" style="vertical-align: super;">元</span>
                      <span class="ft-22" v-if="item.type == 2" style="vertical-align: super;">折</span>
                    </div>
                    <div class="ft-22 color-333">满{{ item.cill }}可用</div>
                  </div>
                  <div style="flex: 1;" class="pd-lt20 pd-rt5">
                    <div class="ft-22 color-333 mg-bt25">{{ item.name }}</div>
                    <div v-if="item.period == 1" class="ft-20 color-666">领券后{{ item.day }}天内有效</div>
                    <div v-if="item.period == 2" class="ft-20 color-666">有效期：{{ item.start_time }} 至 {{ item.end_time }}</div>
                    <div v-if="item.period == 3" class="ft-20 color-666">有效期：长期有效</div>
                  </div>
                </div>
              </div>
              <div class="flex mg-tp10 mg-bt10 mg-rt20" style="justify-content:flex-end;">
                <div class="pagination" v-if="m_count > 0">
                  <van-pagination v-model="m_page" :total-items="m_count" :items-per-page="m_limit" mode="simple" force-ellipses
                    @change="getCouponList" style="background-color: #f2f2f2" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="height: 9rem;"></div>
        <div class="btns flex flex-jc">
          <button class="cancel" @click="closeCouponModal">取消</button>
          <button class="confirm " @click="confirmCouponModal()">确认</button>
        </div>
      </div>
    </div>
    <!-- 选择优惠券 结束 -->
  </div>
</template>

<script>
import titlebar from "@/views/component/titlebar";
import { mapGetters } from 'vuex';
import { datetimePickerFormatter, formatTime } from '../../utils/util';
import popupOfDialog from "../component/popupOfDialog.vue";
export default {
  name: "addWorker",
  components: {
    titlebar,
    popupOfDialog,
  },
  data() {
    return {
      type: '1', // 类型： 1优惠券
      score: "", // 所需积分
      status: true,
      id: '',
      showDialog: false,
      dialogTitle: "",
      dialogMsg: "",
      dialogType: "",
      dialogData: {},
      numberModel: '', // 页面数据参数
      numVal: '', // 数字键盘显示金额
      numValArr: [], // 数字键盘金额数组
      show_keyboard: false,
      platform_name: localStorage.nowDevice || '',
      show_choose_coupon: false,
      select_coupon: {}, // 选中的优惠券
      choosed_coupon: {}, // 已选择的优惠券
      modal_coupon_list: [], // 弹窗内的优惠券数据
      m_page: 1, // 当前页数
      m_limit: 6,
      m_count: 0,
    };
  },
  computed: {
    ...mapGetters({shop: 'shop'})
  },
  async created() {
    this.choosed_coupon = [];
    this.page_name = this.$route.query.name || '';
    this.id = this.$route.query.id || '';
    if (this.id) {
      this.setInfo();
    }
  },
  methods: {
    handleNumChange(e) {
			this.numValArr.push(e);
			this.numVal = this.numValArr.join('');
			this[`${this.numberModel}`] = this.numVal;
		},
		handleNumDelete(e) {
			this.numValArr.pop();
			this.numVal = this.numValArr.length > 0 ? this.numValArr.join('') : '';
			this[`${this.numberModel}`] = this.numVal;
		},
    openKeyboard(name) {
      console.log(this[`${name}`]);
      this.numberModel = name;
      this.numVal = this[`${name}`] || '';
      this.numValArr = this[`${name}`].split('');
      this.show_keyboard = true;
    },
    delScheme() {
      this.$api.deletePointsExchange(this.id).then(res => {
        if (res.code == 1) {
          this.$toast('删除成功');
          this.goBack();
        }
      });
    },
    confirmPopDialog() {
      this.delScheme();
      this.closePopDialog();
    },
    closePopDialog(data) {
      this.showDialog = false;
    },
    openDialog() {
      this.dialogTitle = "提示";
      this.dialogMsg = `是否确认删除？`;
      this.dialogType = '4';
      this.dialogData = {};
      this.showDialog = true;
    },
    setInfo() {
      this.$api.getPointsExchangeInfo(this.id).then(res => {
        if (res.code == 1) {
          this.type = res.data.type.toString();
          this.score = res.data.score.toString();
          this.status = res.data.status == 1; // 状态 1 开启 2 关闭
          this.choosed_coupon = res.data.coupon[0];
          if (this.choosed_coupon.type == 1) {
            this.choosed_coupon.face = this.choosed_coupon.face / 100;
          } else if (this.choosed_coupon.type == 2) {
            this.choosed_coupon.face = this.choosed_coupon.face / 10;
          }
          this.choosed_coupon.cill = this.choosed_coupon.cill / 100;
          if (this.choosed_coupon.period == 2) {
            this.choosed_coupon.start_time = formatTime(new Date(this.choosed_coupon.start_time), 'yyyy-MM-dd');
            this.choosed_coupon.end_time = formatTime(new Date(this.choosed_coupon.end_time), 'yyyy-MM-dd');
          }
        } else {
          this.$toast(res.msg);
        }
      })
    },
    goBack() {
      this.$router.replace({
        name: 'exchange-scheme',
        query: {
          name: 'exchange-scheme',
          active: this.$route.query.active,
        },
      })
    },
    // 提交
    onSubmit(e) {
      if (this.score == '' || !/^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(this.score)) {
        this.$toast('兑换所需积分不允许为0，最多2位小数');
        return;
      }
      if (!Object.keys(this.choosed_coupon).length) {
        this.$toast('请选择优惠券');
        return;
      }
      let data = {
        type: this.type,
        score: this.score,
        status: this.status ? 1 : 2,
        coupon_id: this.choosed_coupon.id,
      };
      if (this.id) {
        data.id = this.id;
        this.editCoupon(data);
      } else {
        this.addCoupon(data);
      }
    },
    addCoupon(query) {
      this.$api.addPointsExchange(query).then(res => {
        if (res.code == 1) {
          this.$toast(res.msg || '新增成功');
          this.goBack();
        } else {
          this.$toast(res.msg);
        }
      })
    },
    editCoupon(query) {
      this.$api.editPointsExchange(this.id, query).then(res => {
        if (res.code == 1) {
          this.$toast('编辑成功');
          this.goBack();
        } else {
          this.$toast(res.msg);
        }
      })
    },
    chooseThatCoupon(item) {
      this.select_coupon = item;
    },
    async confirmCouponModal() {
      this.choosed_coupon = this.select_coupon;
      this.closeCouponModal();
    },
    closeCouponModal() {
      this.show_choose_coupon = false;
    },
    async openCouponModal() {
      this.m_page = 1;
      this.select_coupon = this.choosed_coupon;
      await this.getCouponList();
      this.show_choose_coupon = true;
    },
    getCouponList(type) {
      this.modal_coupon_list = [];
      return new Promise((resolve, reject) => {
        let query = {}
        query = {
          page: this.m_page,
          limit: this.m_limit,
          hidden: 1, // 是否显示过期优惠券 0 显示 1不显示
        }
        this.$api.Coupon_getList(query).then(res => {
          if (res.code = 1) {
            const list = res.data.list || [];
            const count = res.data.count || 0;
            list.forEach(element => {
              if (element.period == 2) {
                element.start_time = formatTime(new Date(element.start_time), 'yyyy-MM-dd');
                element.end_time = formatTime(new Date(element.end_time), 'yyyy-MM-dd');
              }
            });
            this.modal_coupon_list = list || [];
            this.m_count = count || 0;
            resolve();
          } else {
            this.modal_coupon_list = [];
            this.$toast(res.msg);
            resolve();
          }
        })
      })
    },
  },
};
</script>

<style lang="less" scoped>
.otherEatNum-nk {
  border-radius: 0.13rem;
  width: 30vw;
  left: 35vw;
  z-index: 9999;
}
.desk-right {
  height: calc(100% - 10.6rem);
  background-color: #fff;
  margin-top: 1.5rem;
  overflow-y: scroll;

  .switch {
    // margin-top: 0.2rem;
    background: #fff;
    padding-bottom: 2rem;

    .switch-item {
      font-size: 2.4rem;
      height: 9.5rem;
      background-color: #fff;
      // margin-top: 0.05rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 1.2rem;
      border-bottom: 0.15rem solid #eeeeee;
      width: calc(100% - 16.8rem);
      margin: 0 4rem;
    }

    .spt-btns {
      display: flex;
      margin: 5rem auto 2.5rem;
      justify-content: center;
    }

    .switchinput {
      // border: 0.01rem #eeeeee solid;
      border-radius: 0.8rem;
      height: 70%;
      width: 80%;
    }

    .s-i-field {
      width: 80%;
      text-align: left;
    }

    .s-i-field-coupon {
      display: flex;
      align-items: center;
    }

    /deep/.van-radio-group {
      height: 100%;
      width: 80%;
    }

    .auto-height-s-i {
      min-height: 9.5rem;
      height: auto;
      padding: 2.5rem 1.2rem;
    }

    .ff-chaoose-btn {
      width: 16rem;
      height: 6.2rem;
      border-radius: 0.8rem;
      font-size: 2.4rem;
      color: #fff;
      background: #1588F5;
    }

    .c-c-head {
      background: #f2f2f2;
      height: 7.5rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      div {
        flex: 1;
      }
    }

    .c-c-body {
      display: flex;
      align-items: center;
      justify-content: space-between;
      div {
        flex: 1;
        border-bottom: 0.15rem rgba(0, 0, 0, 0.06) solid;
        height: 7.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .stock-input {
        width: 40%;
        height: 6rem;
        border: 0.2rem solid #DEDEDE;
        border-radius: 0.8rem;
        padding: 0 2rem;
        font-size: 2.4rem;
      }
    }
  }

  .foot_btn_box {
    display: flex;
    justify-content: center;
    position: absolute;
    width: 100%;
    bottom: 0;
    background: #fff;
    z-index: 10;
    height: 10rem;
    align-items: center;
    box-shadow: 0 0 0.7rem 0.7rem rgba(229, 229, 229, 0.26);
    left: 0;

    .foot_btn {
      font-size: 2.4rem;
      width: 42rem;
      height: 7rem;
      border-radius: 0.8rem;
      background: #eaeaea;
    }

    .foot_submit {
      color: #fff;
      background-color: #1588f5;
    }
  }

  .add-food {
    height: 100%;
    margin-top: 2rem;
    overflow: scroll;
    overflow-x: hidden;

    .van-cell.van-field {
      font-size: 2.6rem;
      padding: 2rem 3rem;

      /deep/.van-cell__title span {
        line-height: 6rem;
      }

      /deep/.van-field__control {
        min-height: 6rem;

        .van-radio__icon {
          font-size: 2.6rem;
        }

        .van-radio__icon--checked {
          font-size: 2.6rem;

          .van-icon {
            background-color: #1588F5;
            border-color: #1588F5;
          }
        }
      }
    }

    .van-cell.van-field {
      font-size: 2.6rem;

      /deep/textarea.van-field__control::placeholder {
        transform: translateY(0.1rem);
      }

      /deep/.van-field__word-limit {
        font-size: 2.4rem;
      }
    }

    .van-button--normal {
      font-size: 2.6rem;
      background-color: #1588F5;
      border-color: #1588F5;
    }
  }
}

.editdesk-btn {
  width: 42rem;
  height: 8rem;
  border-radius: 0.8rem;
  border: 0;
}

.con {
  height: 100%;
}

.face-price-input {
  width: 12rem;
  height: 6.2rem;
  border: 0.2rem solid #DEDEDE;
  border-radius: 0.8rem;
  padding: 0 2rem;
  font-size: 2.4rem;
}

.choose-coupon-modal {
  text-align: left;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
	
	.modal-content-box {
		width: 72%;
		max-height: 88vh;
		height: fit-content;
		border-radius: 0.8rem;
		background-color: #fff;
	}
	.close {
		width: 2.6rem;
    height: 2.6rem;
		position: absolute;
    right: 2.5rem;
    top: 2.5rem;
		z-index: 10;
	}
	.wrapper {
		padding: 0rem 3.5rem;
		position: relative;
	
		.title {
			padding-top: 2.5rem;
			border-bottom: 0.2rem solid rgba(204, 204, 204, 1);
		}

    .mocontent {
      margin: 2rem 0 1rem;
      position: relative;
      display: flex;
      justify-content: center;
      overflow-y: scroll;
      height: 58vh;
      .deskcontent {
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100%;

        .del-checkbox {
          position: absolute;
          left: 0;
          top: 0;
          background: #fff;
        }
      }
    }
	}
	.btns {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 8.5rem;
		.confirm,
		.cancel {
			color: #fff;
			min-width: 20rem;
			height: 6.5rem;
			border-radius: 0.8rem;
			font-size: 2.4rem;
			padding: 0 2.5rem;
		}
		.cancel {
			background: #EAEAEA;
			color: #666666;
			margin-right: 10rem;
		}
		.confirm {
			background: #1588f5;
		}
	}
}

.index_list {
  width: calc(100% - 4rem);
  // height: 50rem;
  flex: 1;
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 2rem;
  padding-bottom: 2rem;
  display: grid;
  grid-template-columns: repeat(2, 48%);
  grid-template-rows: repeat(auto-fill, 15rem);
  grid-gap: 2.5rem 3%;
  overflow-x: hidden;
  overflow-y: scroll;

  .addpro-index-box {
    display: flex;
    align-items: center;
    justify-content: center !important;
    font-size: 2.8rem;
    color: #1588F5;
    font-weight: bold;
  }

  &::-webkit-scrollbar {
    width: 0;
  }
}
.index_box {
  position: relative;
  // width: 32.9rem;
  // height: 16rem;
  background: #ffffff;
  // box-shadow: 0rem 0.4rem 2rem 0rem rgba(153, 153, 153, 0.2);
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  position: relative;
  padding: 0.5rem 1.5rem;
  height: 15rem;
  border: 0.2rem #cdcdcd solid;
  border-radius: 0.8rem;

  .coupon-tag-img {
    position: absolute;
    top: -1.2rem;
    right: 0;
    width: 11rem;
    height: 11rem;
  }

  .coupon-left {
    width: 26.5%;
    position: relative;
  }
  .coupon-left::after {
    content: '';
    width: 0.15rem;
    height: 132%;
    position: absolute;
    right: 0;
    top: -15%;
    border-right: 0.15rem dashed #E5E5E5;
  }
}

.pagination {
  width: 30%;
  /deep/.van-pagination {
    font-size: 1.9rem;
  }
  /deep/.van-pagination__item--active {
    background-color: #1588F5;
  }
}

.choosed-coupon-box {
  margin-left: 3rem;
  width: 57rem;
}
</style>
